/**
 * Created by Макс on 31.10.2017.
 */
/**
 * Created by Макс on 16.10.2017.
 */
import { Component, ElementRef } from '@angular/core';
import { Broadcaster } from '../service/Broadcaster';
import { SingService } from '../service/sing.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'dealer-settings-app',
    templateUrl: 'dealer-settings.html',
    styleUrls: ['add-access/bootstrap.min.css', 'add-access/update.css', 'add-access/style.css'], //left-menu/style.min.css
})
export class DealerSettingsComponent {
    rightMenu: any = [

    ];
    itemMenu: number = 0;
    dealerGroupId: number;
    sub: any;
    constructor(
        private broadcaster: Broadcaster,
        private elementRef: ElementRef,
        private httpService: SingService,
        private route: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() {
        /*
     if (!this.httpService.getAuthData()) {
     window.location.pathname = '/';
     }
     this.broadcaster.on<string>('AuthError').subscribe(message => {
     console.log('message', message);
     if (message === '401') {
     this.httpService.LogOut().subscribe(data => {
     if (data.status === 401) {
     window.localStorage.clear();
     window.sessionStorage.clear();
     window.location.pathname = '/';
     }
     });
     }
     });*/
        /* this.broadcaster.on<any>('rooftops').subscribe(data => {
             this.rightMenu = data.iteшвшвidid
             wefwefwefwefms;
         });*/
        this.sub = this.route.queryParams.subscribe(params => {
            // Defaults to 0 if no query param provided.
            this.dealerGroupId = +params['id'] || 0;
            /* this.broadcaster.broadcast('updateGLMenu', {
                 id: this.dealerGroupId,
             });*/
            this.broadcaster.broadcast('userId', {
                id: this.dealerGroupId

            });
            this.httpService
                .getDealerRooftops({
                    dealerGroupId: this.dealerGroupId
                })
                .subscribe(data => {
                    if (data.status === 200) {
                        //  console.log('data', data);
                        this.rightMenu = data.data;
                        this.broadcaster.broadcast('rooftopsSelect', {
                            id: data.data[0].id
                        });
                        this.broadcaster.broadcast('rooftops', {
                            items: data.data

                        });
                        window.localStorage.setItem("dealerUpload", JSON.stringify({ id: this.dealerGroupId, rooftop: data.data[0].id }));
                    }
                });
            this.broadcaster.on<any>('update').subscribe(data => {
                this.itemMenu = data.item;
            });
        });
    }
    SelectRootfrop(id: number, event: any) {
        event.preventDefault();
        this.broadcaster.broadcast('rooftopsSelect', {
            id: id
        });
        window.localStorage.setItem("dealerUpload", JSON.stringify({ id: this.dealerGroupId, rooftop: id }));
        $(".nav-item").removeClass("active");
        $(event.target).addClass("active");

    }
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    UpdateFirst(id: number) {
        if (id === this.rightMenu[0].id) {
            return 'active';
        }
        return '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dealer/dealer-settings.ts